'use strict';
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/validate-arguments-length.js
// module id = 267
// module chunks = 13